export default "__VITE_ASSET__CpIX0TNB__"